import { EnabledIconProps, IconProps } from './IconProps';

export const MobilePhoneIcon = ({
  className,
  height = 8,
  width = 11,
  enabled = false,
}: IconProps & EnabledIconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 7 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0 .5)" fill="none" fillRule="evenodd">
      <rect fill={enabled ? '#2396FD' : '#B2B2B2'} width="7" height="11" rx="1" />
      <path fill="#FFF" d="M1 3h5v7H1zM2 1h3v1H2z" />
    </g>
  </svg>
);
